import {IRoutableModule} from '../../router/routing.infra';
import {LoginCallbackView} from './login-callback.view';
import {loginCallbackRouteLoader} from './login-callback.loader';

export default {
    loader: loginCallbackRouteLoader,
    Component: LoginCallbackView,
    storeAs: 'loginCallbackStore'
} as IRoutableModule;
